export default __webpack_public_path__ + "static/shopnowSupps-8c0258a76eecd722f43e062272981c08.png";